import { render, staticRenderFns } from "./COMWizard.vue?vue&type=template&id=27f86045"
import script from "./COMWizard.vue?vue&type=script&lang=js"
export * from "./COMWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports